import { Editor } from '@tiptap/react';

interface VariablesModalProps {
  editor: Editor | null;
  onClose: () => void;
  anchorRect?: DOMRect | null;
}

export const VARIABLES = [
  { label: 'Client First Name',   value: '{{client_first_name}}' },
  { label: 'Client Last Name',    value: '{{client_last_name}}' },
  { label: 'Client Full Name',    value: '{{client_full_name}}' },
  { label: 'Client Company Name', value: '{{client_company_name}}' },
  { label: 'Sender Name',         value: '{{sender_name}}' },
  { label: 'Sender Company Name', value: '{{sender_company_name}}' },
];

const POPUP_WIDTH = 320;
const POPUP_GAP = 6;
const SCREEN_PADDING = 8;

function getPopupStyle(anchorRect: DOMRect | null | undefined): React.CSSProperties {
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  if (!anchorRect) {
    return {
      bottom: SCREEN_PADDING,
      left: SCREEN_PADDING,
      maxHeight: vh - SCREEN_PADDING * 2,
    };
  }

  const spaceAbove = anchorRect.top - SCREEN_PADDING;
  const spaceBelow = vh - anchorRect.bottom - SCREEN_PADDING;

  // Align left with button, clamp to viewport
  let left = anchorRect.left;
  if (left + POPUP_WIDTH > vw - SCREEN_PADDING) {
    left = vw - POPUP_WIDTH - SCREEN_PADDING;
  }
  if (left < SCREEN_PADDING) left = SCREEN_PADDING;

  if (spaceAbove > spaceBelow) {
    // Open upward — bottom of popup sits just above the button
    return {
      bottom: vh - anchorRect.top + POPUP_GAP,
      left,
      maxHeight: spaceAbove,
    };
  } else {
    // Open downward
    return {
      top: anchorRect.bottom + POPUP_GAP,
      left,
      maxHeight: spaceBelow,
    };
  }
}

export default function VariablesModal({ editor, onClose, anchorRect }: VariablesModalProps) {
  const handleInsert = (variable: string) => {
    if (!editor) return;
    editor.chain().focus().insertContent(variable).run();
    onClose();
  };

  const style = getPopupStyle(anchorRect);

  return (
    <div className="var-modal-overlay">
      <div
        className="var-modal"
        style={{ position: 'fixed', display: 'flex', flexDirection: 'column', ...style }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Sticky header — always visible */}
        <div className="var-modal-header">
          <span className="var-modal-title">Insert Variable</span>
          <button className="var-modal-close" type="button" onClick={onClose}>✕</button>
        </div>
        <p className="var-modal-hint">Click a variable to insert it at the cursor position.</p>

        {/* Scrollable variable list */}
        <div className="var-modal-grid">
          {VARIABLES.map((v) => (
            <button
              key={v.value}
              className="var-chip"
              type="button"
              onClick={() => handleInsert(v.value)}
            >
              <span className="var-chip-value">{v.value}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
